import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import logo from '../../Assets/logo.png';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  return (
    <header className="absolute top-0 left-0 right-0 z-50 py-4">
      <div className="container mx-auto px-6 md:px-12 flex items-center justify-between">
        <Link to="/" className="flex items-center">
          <img src={logo} alt="House of Praise Logo" className="h-16 w-16" />
        </Link>
        
        {/* Desktop Navigation */}
        <nav className="hidden md:flex space-x-6 font-sf-pro">
          <NavLink to="/" className={({ isActive }) => isActive ? "text-white font-medium border-b-2 border-white" : "text-white font-medium hover:border-b-2 hover:border-white transition-all"}>Home</NavLink>
          <NavLink to="/about" className={({ isActive }) => isActive ? "text-white font-medium border-b-2 border-white" : "text-white font-medium hover:border-b-2 hover:border-white transition-all"}>About us</NavLink>
          <NavLink to="/sermon" className={({ isActive }) => isActive ? "text-white font-medium border-b-2 border-white" : "text-white font-medium hover:border-b-2 hover:border-white transition-all"}>Sermon</NavLink>
          <NavLink to="/ministries" className={({ isActive }) => isActive ? "text-white font-medium border-b-2 border-white" : "text-white font-medium hover:border-b-2 hover:border-white transition-all"}>Ministries</NavLink>
          <NavLink to="/events" className={({ isActive }) => isActive ? "text-white font-medium border-b-2 border-white" : "text-white font-medium hover:border-b-2 hover:border-white transition-all"}>Events</NavLink>
          <NavLink to="/contact" className={({ isActive }) => isActive ? "text-white font-medium border-b-2 border-white" : "text-white font-medium hover:border-b-2 hover:border-white transition-all"}>Contact us</NavLink>
          <NavLink to="/giving" className={({ isActive }) => isActive ? "text-white font-medium border-b-2 border-white" : "text-white font-medium hover:border-b-2 hover:border-white transition-all"}>Giving</NavLink>
        </nav>

        {/* Mobile Menu Toggle Button */}
        <div className="md:hidden">
          <button 
            onClick={toggleMobileMenu}
            className="text-white focus:outline-none"
            aria-label="Toggle mobile menu"
          >
            {mobileMenuOpen ? (
              // Close Icon (X)
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            ) : (
              // Hamburger Icon
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            )}
          </button>
        </div>
      </div>

      {/* Mobile Menu with Smooth Animation */}
      <div 
        className={`md:hidden absolute top-full left-0 right-0 overflow-hidden transition-all duration-300 ease-in-out ${
          mobileMenuOpen ? 'max-h-screen opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="bg-white/10 backdrop-blur-lg border-t border-white/20 shadow-2xl">
          <nav className="flex flex-col space-y-2 px-6 py-6 font-sf-pro">
            <NavLink 
              to="/" 
              onClick={closeMobileMenu}
              className={({ isActive }) => 
                isActive 
                  ? "text-white font-semibold bg-white/20 backdrop-blur-sm rounded-lg px-4 py-3 border-l-4 border-white transition-all duration-200" 
                  : "text-white font-medium hover:bg-white/10 hover:backdrop-blur-sm rounded-lg px-4 py-3 hover:border-l-4 hover:border-white transition-all duration-200"
              }
            >
              Home
            </NavLink>
            <NavLink 
              to="/about" 
              onClick={closeMobileMenu}
              className={({ isActive }) => 
                isActive 
                  ? "text-white font-semibold bg-white/20 backdrop-blur-sm rounded-lg px-4 py-3 border-l-4 border-white transition-all duration-200" 
                  : "text-white font-medium hover:bg-white/10 hover:backdrop-blur-sm rounded-lg px-4 py-3 hover:border-l-4 hover:border-white transition-all duration-200"
              }
            >
              About us
            </NavLink>
            <NavLink 
              to="/sermon" 
              onClick={closeMobileMenu}
              className={({ isActive }) => 
                isActive 
                  ? "text-white font-semibold bg-white/20 backdrop-blur-sm rounded-lg px-4 py-3 border-l-4 border-white transition-all duration-200" 
                  : "text-white font-medium hover:bg-white/10 hover:backdrop-blur-sm rounded-lg px-4 py-3 hover:border-l-4 hover:border-white transition-all duration-200"
              }
            >
              Sermon
            </NavLink>
            <NavLink 
              to="/ministries" 
              onClick={closeMobileMenu}
              className={({ isActive }) => 
                isActive 
                  ? "text-white font-semibold bg-white/20 backdrop-blur-sm rounded-lg px-4 py-3 border-l-4 border-white transition-all duration-200" 
                  : "text-white font-medium hover:bg-white/10 hover:backdrop-blur-sm rounded-lg px-4 py-3 hover:border-l-4 hover:border-white transition-all duration-200"
              }
            >
              Ministries
            </NavLink>
            <NavLink 
              to="/events" 
              onClick={closeMobileMenu}
              className={({ isActive }) => 
                isActive 
                  ? "text-white font-semibold bg-white/20 backdrop-blur-sm rounded-lg px-4 py-3 border-l-4 border-white transition-all duration-200" 
                  : "text-white font-medium hover:bg-white/10 hover:backdrop-blur-sm rounded-lg px-4 py-3 hover:border-l-4 hover:border-white transition-all duration-200"
              }
            >
              Events
            </NavLink>
            <NavLink 
              to="/contact" 
              onClick={closeMobileMenu}
              className={({ isActive }) => 
                isActive 
                  ? "text-white font-semibold bg-white/20 backdrop-blur-sm rounded-lg px-4 py-3 border-l-4 border-white transition-all duration-200" 
                  : "text-white font-medium hover:bg-white/10 hover:backdrop-blur-sm rounded-lg px-4 py-3 hover:border-l-4 hover:border-white transition-all duration-200"
              }
            >
              Contact us
            </NavLink>
            <NavLink 
              to="/giving" 
              onClick={closeMobileMenu}
              className={({ isActive }) => 
                isActive 
                  ? "text-white font-semibold bg-white/20 backdrop-blur-sm rounded-lg px-4 py-3 border-l-4 border-white transition-all duration-200" 
                  : "text-white font-medium hover:bg-white/10 hover:backdrop-blur-sm rounded-lg px-4 py-3 hover:border-l-4 hover:border-white transition-all duration-200"
              }
            >
              Giving
            </NavLink>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;